import DataStore from '../../DataStore';
import { IJpInfoData } from '../../../interface/IFooter';

export default class infoJP {
  private ds: DataStore;

  constructor(_wrapper: HTMLElement) {
    this.ds = DataStore.instance;
    const infoData = this.getInfoData(this.ds.service);

    if (infoData) {
      _wrapper.classList.add('footer-info-jp');
      _wrapper.innerHTML = this.templ(infoData);
    }
  }

  templ(_data: IJpInfoData) {
    return `
        <div class="info-wrap">
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpTitle}</div>
                <div class="info-text">${_data.title}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpGenre}</div>
                <div class="info-text">${_data.genre}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpPrice}</div>
                <div class="info-text">${this.ds.l10n.infoJP.jpPriceValue}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpOs}</div>
                <div class="info-text">${_data.os}</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpDevelopedBy}</div>
                <div class="info-text">NCSOFT</div>
            </div>
            <div class="info-item">
                <div class="info-title">${this.ds.l10n.infoJP.jpReleaseDay}</div>
                <div class="info-text">${_data.releaseDay}</div>
            </div>
        </div>
        `;
  }

  getInfoData(_service: string) {
    if (_service === 'lineagew') {
      let resultInfoData: IJpInfoData = {
        title: 'リネージュ W',
        genre: 'MMORPG',
        os: 'iOS/Android/Windows',
        releaseDay: this.ds.l10n.infoJP.jpReleaseDayValue_LW,
      };

      return resultInfoData;
    }
    if (_service === 'lineage2mncj') {
      let resultInfoData: IJpInfoData = {
        title: 'リネージュ2M',
        genre: 'MMORPG',
        os: 'iOS/Android/Windows',
        releaseDay: '2021年3月24日',
      };

      return resultInfoData;
    }

    //bns2
    if (_service === 'bns2') {
      let resultInfoData: IJpInfoData = {
        title: 'ブレイドアンドソウル2',
        genre: 'ソウルアクションRPG',
        os: 'iOS/Android/Windows',
        releaseDay: '2023年8月23日',
      };

      return resultInfoData;
    }

    //puzzup
    if (_service === 'puzzup') {
      let resultInfoData: IJpInfoData = {
        title: 'PUZZUP AMITOI',
        genre: 'パズルゲーム',
        os: 'iOS/Android',
        releaseDay: '2023年9月26日',
      };

      return resultInfoData;
    }

    //배틀크러쉬
    if (_service === 'battlecrush') {
      let resultInfoData: IJpInfoData = {
        title: 'バトルクラッシュ',
        genre: 'MOBA',
        os: 'IOS / Android / Windows /<br />nintendo switch',
        releaseDay: '2024年6月27日',
      };

      return resultInfoData;
    }

    // 저니오브 모나크  
    if (_service === 'journey') {
      let resultInfoData: IJpInfoData = {
        title: 'Journey of Monarch - 君主の道',
        genre: 'ロールプレイング',
        os: 'iOS / Android / Windows',
        releaseDay: '2024年12月05日',
      };

      return resultInfoData;
    }
    return false;
  }
}
